import { OfferType } from "@leplein/graphql-public/clients/graphql-qrcode-client/graphql";

/** Tier display order; UNKNOWN kept last so unmatched types don't sort to the front. */
const OFFER_TYPE_ORDER: OfferType[] = [OfferType.Eco, OfferType.Fast, OfferType.Ultra, OfferType.Unknown];

/** Returns a new array of offers ordered by tier: ECO → FAST → ULTRA (UNKNOWN last). */
export const sortOffersByType = <T extends { type: OfferType }>(offers: readonly T[]): T[] =>
	[...offers].sort((a, b) => OFFER_TYPE_ORDER.indexOf(a.type) - OFFER_TYPE_ORDER.indexOf(b.type));
